export const ENUM_KTM = 'KTM';
export const ENUM_BMW = 'BMW';
export const ENUM_TRIUMPH = 'Triumph';
